import React from 'react';

import { ContactFlowNodeProps } from '..';
import BaseNode from '../BaseNode';

export default function LexBotAudioNode(props: ContactFlowNodeProps) {
  return <BaseNode {...props} title='Lex Bot Audio' />;
}
